
import { useState, useEffect } from 'react';

type DeviceOrientation = 'portrait' | 'landscape';

export const useDeviceOrientation = () => {
  const [orientation, setOrientation] = useState<DeviceOrientation>('portrait');
  const [hasRotated, setHasRotated] = useState(false);

  useEffect(() => {
    const getOrientation = (): DeviceOrientation => {
      if (typeof window === 'undefined') return 'portrait';
      return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
    };

    const updateOrientation = () => {
      const newOrientation = getOrientation();
      const previousOrientation = orientation;
      
      setOrientation(newOrientation);
      
      // Track if user has rotated at least once
      if (previousOrientation !== newOrientation) {
        setHasRotated(true);
      }
    };

    // Initial check
    updateOrientation();

    // Add event listeners
    window.addEventListener('resize', updateOrientation);
    window.addEventListener('orientationchange', updateOrientation);

    return () => {
      window.removeEventListener('resize', updateOrientation);
      window.removeEventListener('orientationchange', updateOrientation);
    };
  }, [orientation]);

  return {
    orientation,
    isLandscape: orientation === 'landscape',
    isPortrait: orientation === 'portrait',
    hasRotated
  };
};
